import { BookmarkInfo } from "@/types";

export function getPresetShortcutTitles(): BookmarkInfo[] {
	const titles = [
		"translate",
		"aiTools",
		"image",
		"notes",
		"airportal",
		"qqMail",
		"cloudMusic",
		"bilibili",
		"wallpaper",
		"darkMode",
	];
	return titles.map((title) => {
		return {
			icon: "",
			id: title,
			itemType: "preset",
			title: title,
			url: null,
		};
	});
}
